import { environment } from '../../../../web-app/src/environments/environment';

export const storagePrefix = environment.environmentStoragePrefix + 'cloudOTDR';
